<section class="content">
    <!--Input box form floating-->
<div class="container-fluid">
    <div class="row mt-3 mb-3">
        <div class="col-lg-6">
            <h6 class="mt-2 text-bold">Input Fields</h6>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-lg-3">
            <div class="form-floating mb-3">
                <input type="email" class="form-control" id="floatingInput" placeholder="name@example.com">
                <label class="text-bold">Label</label>
            </div>
        </div>

        <div class="col-lg-3">
            <div class="form-floating">
                <textarea class="form-control" placeholder="Leave a comment here" id="floatingTextarea"></textarea>
                <label for="floatingTextarea">Comments</label>
            </div>
        </div>

        <div class="col-lg-3">
            <div class="form-floating">
                <select class="form-select" id="floatingSelect" aria-label="Floating label select example">
                    <option selected>Open this select menu</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                </select>
                <label for="floatingSelect">Works with selects</label>
            </div>
        </div>

        <div class="col-lg-3">
          <div class="row">
              <div class="col-lg-4 col-12">
                  <div class="form-check mt-3">
                      <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                      <label class="form-check-label" for="flexCheckDefault">
                          checkbox
                      </label>
                  </div>
              </div>

              <div class="col-lg-4 col-12">
                  <div class="form-check mt-3">
                      <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1">
                      <label class="form-check-label" for="flexRadioDefault1">
                          radio
                      </label>
                  </div>
              </div>

              <div class="col-lg-4 col-12">
                  <div class="form-check form-switch mt-3">
                      <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                      <label class="form-check-label" for="flexSwitchCheckDefault">switch</label>
                  </div>
              </div>
          </div>
        </div>
    </div>


    <div class="row mt-3 mb-3">
        <div class="col-lg-6">
            <h6 class="text-bold">Table</h6>
        </div>
    </div>

    <div class="row mt-3 mb-3">
        <div class="col-lg-12">
            <table class="table table-bordered border-dark">
                <thead>
               <tr>
                   <th class="text-center">Head</th>
                   <th class="text-center">Head</th>
                   <th class="text-center">Head</th>
                   <th class="text-center">Head</th>
               </tr>
                </thead>
                <tbody>
                <tr>
                    <th scope="row" class="text-center">1</th>
                    <td class="text-center">Mark</td>
                    <td class="text-center">Otto</td>
                    <td class="text-center">@mdo</td>
                </tr>
                <tr>
                    <th class="text-center">2</th>
                    <td class="text-center">Jacob</td>
                    <td class="text-center">Thornton</td>
                    <td class="text-center">@fat</td>
                </tr>
                <tr>
                    <th class="text-center">3</th>
                    <td class="text-center">Larry the Bird</td>
                    <td class="text-center">@twitter</td>
                    <td class="text-center">@twitter</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="row mt-3 mb-3">

        <h6 class="text-bold">Info Box</h6>
        <div class="row">
            <div class="col-md-3 col-sm-6 col-12">
                <div class="info-box bg-info">
                    <span class="info-box-icon"><i class="far fa-bookmark"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text">Bookmarks</span>
                        <span class="info-box-number">41,410</span>
                        <div class="progress">
                            <div class="progress-bar" style="width: 70%"></div>
                        </div>
                        <span class="progress-description">70% Increase in 30 Days</span>
                    </div>
                </div>
            </div>

            <div class="col-md-3 col-sm-6 col-12">
                <div class="info-box bg-success">
                    <span class="info-box-icon"><i class="far fa-thumbs-up"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text">Likes</span>
                        <span class="info-box-number">41,410</span>
                        <div class="progress">
                            <div class="progress-bar" style="width: 70%"></div>
                        </div>
                        <span class="progress-description">70% Increase in 30 Days</span>
                    </div>
                </div>
            </div>

            <div class="col-md-3 col-sm-6 col-12">
                <div class="info-box bg-warning">
                    <span class="info-box-icon"><i class="far fa-calendar-alt"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text">Events</span>
                        <span class="info-box-number">41,410</span>
                        <div class="progress">
                            <div class="progress-bar" style="width: 70%"></div>
                        </div>
                        <span class="progress-description">70% Increase in 30 Days</span>
                    </div>
                </div>
            </div>

            <div class="col-md-3 col-sm-6 col-12">
                <div class="info-box bg-danger">
                    <span class="info-box-icon"><i class="fas fa-comments"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text">Comments</span>
                        <span class="info-box-number">41,410</span>
                        <div class="progress">
                            <div class="progress-bar" style="width: 70%"></div>
                        </div>
                        <span class="progress-description">70% Increase in 30 Days</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-2">
            <h6 class="text-bold">Small Box</h6>

            <div class="row">
                <div class="col-lg-3 col-6">

                    <div class="small-box bg-info">
                        <div class="inner">
                            <h3>150</h3>
                            <p>New Orders</p>
                        </div>
                        <div class="icon">
                            <i class="fas fa-shopping-cart"></i>
                        </div>
                        <a href="#" class="small-box-footer">
                            More info <i class="fas fa-arrow-circle-right"></i>
                        </a>
                    </div>
                </div>

                <div class="col-lg-3 col-6">

                    <div class="small-box bg-success">
                        <div class="inner">
                            <h3>53<sup style="font-size: 20px">%</sup></h3>
                            <p>Bounce Rate</p>
                        </div>
                        <div class="icon">
                            <i class="ion ion-stats-bars"></i>
                        </div>
                        <a href="#" class="small-box-footer">
                            More info <i class="fas fa-arrow-circle-right"></i>
                        </a>
                    </div>
                </div>

                <div class="col-lg-3 col-6">

                    <div class="small-box bg-warning">
                        <div class="inner">
                            <h3>44</h3>
                            <p>User Registrations</p>
                        </div>
                        <div class="icon">
                            <i class="fas fa-user-plus"></i>
                        </div>
                        <a href="#" class="small-box-footer">
                            More info <i class="fas fa-arrow-circle-right"></i>
                        </a>
                    </div>
                </div>

                <div class="col-lg-3 col-6">

                    <div class="small-box bg-danger">
                        <div class="inner">
                            <h3>65</h3>
                            <p>Unique Visitors</p>
                        </div>
                        <div class="icon">
                            <i class="fas fa-chart-pie"></i>
                        </div>
                        <a href="#" class="small-box-footer">
                            More info <i class="fas fa-arrow-circle-right"></i>
                        </a>
                    </div>
                </div>

            </div>
        </div>

        <div class="row mt-3">
            <div class="col-12 ml-2">
                <div class="card">
                    <div class="card-header d-flex">
                        <h3 class="card-title p-3">Tabs</h3>
                        <ul class="nav nav-pills ml-auto p-2">
                            <li class="nav-item"><a class="nav-link" (click)="changeTab('tab_1')" [class.active]="activeTab === 'tab_1'">Tab 1</a></li>
                            <li class="nav-item"><a class="nav-link" (click)="changeTab('tab_2')" [class.active]="activeTab === 'tab_2'">Tab 2</a></li>
                            <li class="nav-item"><a class="nav-link" (click)="changeTab('tab_3')" [class.active]="activeTab === 'tab_3'">Tab 3</a></li>
                            <li class="nav-item dropdown">
                                <!-- ... (your existing dropdown code) -->
                            </li>
                        </ul>
                    </div>
                    <div class="card-body">
                        <div class="tab-content">
                            <div class="tab-pane" *ngIf="activeTab === 'tab_1'">
                                A wonderful serenity has taken possession of my entire soul, like these sweet mornings of spring...
                                dslad;lkdklkasdpkopedw
                            </div>
                            <div class="tab-pane" *ngIf="activeTab === 'tab_2'">
                                The European languages are members of the same family. Their separate existence is a myth...
                            </div>
                            <div class="tab-pane" *ngIf="activeTab === 'tab_3'">
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been...
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Progress Bars Different Sizes</h3>
                    </div>

                    <div class="card-body">
                        <p><code>.progress</code></p>
                        <div class="progress">
                            <div class="progress-bar bg-primary progress-bar-striped" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">
                                <span class="sr-only">40% Complete (success)</span>
                            </div>
                        </div>
                        <p><code>.progress-sm</code></p>
                        <div class="progress progress-sm active">
                            <div class="progress-bar bg-success progress-bar-striped" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">
                                <span class="sr-only">20% Complete</span>
                            </div>
                        </div>
                        <p><code>.progress-xs</code></p>
                        <div class="progress progress-xs">
                            <div class="progress-bar bg-warning progress-bar-striped" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">
                                <span class="sr-only">60% Complete (warning)</span>
                            </div>
                        </div>
                        <p><code>.progress-xxs</code></p>
                        <div class="progress progress-xxs">
                            <div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">
                                <span class="sr-only">60% Complete (warning)</span>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div class="col-md-6">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Progress bars</h3>
                    </div>

                    <div class="card-body">
                        <div class="progress mb-3">
                            <div class="progress-bar bg-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">
                                <span class="sr-only">40% Complete (success)</span>
                            </div>
                        </div>
                        <div class="progress mb-3">
                            <div class="progress-bar bg-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">
                                <span class="sr-only">20% Complete</span>
                            </div>
                        </div>
                        <div class="progress mb-3">
                            <div class="progress-bar bg-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">
                                <span class="sr-only">60% Complete (warning)</span>
                            </div>
                        </div>
                        <div class="progress mb-3">
                            <div class="progress-bar bg-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">
                                <span class="sr-only">80% Complete</span>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>

        <div class="row mt-3">
            <div class="col-lg-11 ml-3">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Fixed Header Table</h3>
                        <div class="card-tools">
                            <div class="input-group input-group-sm" style="width: 150px;">
                                <input type="text" name="table_search" class="form-control float-right" placeholder="Search">
                                <div class="input-group-append">
                                    <button type="submit" class="btn btn-default">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card-body table-responsive p-0" style="height: 300px;">
                        <table class="table table-head-fixed text-nowrap">
                            <thead>
                            <tr>
                                <th class="text-center">ID</th>
                                <th class="text-center">User</th>
                                <th class="text-center">Date</th>
                                <th class="text-center">Status</th>
                                <th class="text-center">Reason</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="text-center">183</td>
                                <td class="text-center">John Doe</td>
                                <td class="text-center">11-7-2014</td>
                                <td class="text-center"><span class="tag tag-success">Approved</span></td>
                                <td class="text-center">Bacon ipsum dolor sit amet salami venison chicken flank fatback doner.</td>
                            </tr>
                            <tr>
                                <td class="text-center">219</td>
                                <td class="text-center">Alexander Pierce</td>
                                <td class="text-center">11-7-2014</td>
                                <td class="text-center"><span class="tag tag-warning">Pending</span></td>
                                <td class="text-center">Bacon ipsum dolor sit amet salami venison chicken flank fatback doner.</td>
                            </tr>
                            <tr>
                                <td class="text-center">657</td>
                                <td class="text-center">Bob Doe</td>
                                <td class="text-center">11-7-2014</td>
                                <td class="text-center"><span class="tag tag-primary">Approved</span></td>
                                <td class="text-center">Bacon ipsum dolor sit amet salami venison chicken flank fatback doner.</td>
                            </tr>
                            <tr>
                                <td class="text-center">175</td>
                                <td class="text-center">Mike Doe</td>
                                <td class="text-center">11-7-2014</td>
                                <td class="text-center"><span class="tag tag-danger">Denied</span></td>
                                <td class="text-center">Bacon ipsum dolor sit amet salami venison chicken flank fatback doner.</td>
                            </tr>
                            <tr>
                                <td class="text-center">134</td>
                                <td class="text-center">Jim Doe</td>
                                <td class="text-center">11-7-2014</td>
                                <td class="text-center"><span class="tag tag-success">Approved</span></td>
                                <td class="text-center">Bacon ipsum dolor sit amet salami venison chicken flank fatback doner.</td>
                            </tr>
                            <tr>
                                <td>494</td>
                                <td>Victoria Doe</td>
                                <td>11-7-2014</td>
                                <td><span class="tag tag-warning">Pending</span></td>
                                <td>Bacon ipsum dolor sit amet salami venison chicken flank fatback doner.</td>
                            </tr>
                            <tr>
                                <td>832</td>
                                <td>Michael Doe</td>
                                <td>11-7-2014</td>
                                <td><span class="tag tag-primary">Approved</span></td>
                                <td>Bacon ipsum dolor sit amet salami venison chicken flank fatback doner.</td>
                            </tr>
                            <tr>
                                <td>982</td>
                                <td>Rocky Doe</td>
                                <td>11-7-2014</td>
                                <td><span class="tag tag-danger">Denied</span></td>
                                <td>Bacon ipsum dolor sit amet salami venison chicken flank fatback doner.</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
</section>